export const toCents = (value: string) => {
  if (!/^\d+(?:\.\d{1,2})?$/.test(value)) return NaN
  const [dollars, cents = ''] = value.split('.')
  const result = Number(dollars) * 100 + Number(cents.padEnd(2, '0'))
  return Number.isSafeInteger(result) && result <= 2147483647 ? result : NaN
}

export const isValidAmount = (value: string, positive = false) => {
  const cents = toCents(value)
  return Number.isFinite(cents) && (!positive || cents > 0)
}

export const isValidTerm = (value: string) =>
  /^\d+$/.test(value) &&
  Number.isSafeInteger(Number(value)) &&
  Number(value) >= 0 &&
  Number(value) <= 2147483647

export const toLocalDateTime = (value: number) => {
  if (value === 0) return ''
  const date = new Date(value)
  const pad = (part: number, length = 2) => String(part).padStart(length, '0')
  return `${pad(date.getFullYear(), 4)}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${pad(date.getMilliseconds(), 3)}`
}

export const toEpoch = (value: string, initial?: { local: string; epoch: number }) => {
  // Re-parsing a repeated DST hour can select a different instant.
  if (initial && value === initial.local) return initial.epoch
  return value === '' ? 0 : new Date(value).getTime()
}

export const validateDateRange = (from: number, to: number) => {
  if (!Number.isSafeInteger(from) || !Number.isSafeInteger(to)) return 'Enter a valid date and time'
  return from === 0 || to === 0 || to > from || 'End must be later than start'
}
